// extracted by mini-css-extract-plugin
export default {"face-button":"Faces_face-button__QMOzy","face-button-selected":"Faces_face-button-selected__PGLS2","face-button-image":"Faces_face-button-image__JXV9x"};